import { getProblemType } from "../api/permissionEvents";

// 권한 관리 API 오류(problem-details data.type) → 사람이 이해할 수 있는 문구 (spec 6, RUB-UX-01)
export const ACCESS_ERROR_MESSAGES = {
  "/errors/permission/lockout":
    "이 변경을 적용하면 권한 관리자(권한 관리 변경 권한 보유자)가 한 명도 남지 않게 되어 변경할 수 없습니다. 다른 관리자에게 먼저 권한을 준 뒤 다시 시도해 주세요.",
  "/errors/permission/denied": "이 작업을 할 권한이 없습니다. 권한 관리자에게 요청해 주세요.",
  "/errors/permission/key-not-found": "존재하지 않는 권한입니다. 화면을 새로고침한 뒤 다시 시도해 주세요.",
  "/errors/permission/role-not-found": "존재하지 않는 역할입니다. 화면을 새로고침한 뒤 다시 시도해 주세요.",
  "/errors/permission/role-key-duplicated": "이미 사용 중인 역할 키입니다. 다른 키를 입력해 주세요.",
  "/errors/permission/system-role-immutable": "시스템 역할은 삭제하거나 키를 바꿀 수 없습니다. (권한 편집은 가능합니다)",
  "/errors/permission/admin-not-found": "존재하지 않는 어드민 계정입니다.",
  "/errors/permission/invalid-expires-at":
    "만료일은 지금 이후여야 하며, '역할 따름'과 함께 지정할 수 없습니다.",
};

export function getAccessErrorMessage(error, fallback = "요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.") {
  const type = getProblemType(error);
  if (type && ACCESS_ERROR_MESSAGES[type]) return ACCESS_ERROR_MESSAGES[type];
  const status = error?.response?.status;
  if (status === 400) return "입력값을 확인해 주세요. 사유는 공백이 아닌 1~200자여야 합니다.";
  if (status === 401) return "로그인이 만료되었습니다. 다시 로그인해 주세요.";
  if (status === 403) return ACCESS_ERROR_MESSAGES["/errors/permission/denied"];
  if (status === 404) return "권한 관리 API를 찾을 수 없습니다. 서버 배포 상태를 확인해 주세요.";
  return fallback;
}

// 실효 결과 출처 (R-RESOLVE-03) → 표시 문구
export function describeSource(source, roleKeys = []) {
  switch (source) {
    case "ROLE":
      return `역할: ${roleKeys.join(", ")}`;
    case "ALLOW_OVERRIDE":
      return "개인 예외(허용)";
    case "DENY_OVERRIDE":
      return "개인 예외(차단)";
    case "UNKNOWN_KEY":
      return "알 수 없는 권한";
    case "NONE":
    default:
      return "해당 역할 없음";
  }
}

// 3상태 토글 (R-MGMT-04, R-FE-06)
export const OVERRIDE_STATES = [
  { value: "INHERIT", label: "역할 따름" },
  { value: "ALLOW", label: "허용" },
  { value: "DENY", label: "차단" },
];

/** 행의 현재 토글 상태. 만료된 예외는 판정에서 무시되므로 '역할 따름'으로 본다. */
export function currentOverrideState(row) {
  const o = row?.override;
  if (!o || o.expired) return "INHERIT";
  return o.effect;
}

export const overrideLabel = (value) => OVERRIDE_STATES.find((s) => s.value === value)?.label ?? value;

/** reason 검증 (R-GOV-01: 공백 제외 1~200자) */
export function isValidReason(reason) {
  return typeof reason === "string" && reason.trim().length >= 1 && reason.length <= 200;
}

export function formatDateTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
